
























import { computed } from '@vue/composition-api'
import { defineClassComponent, useMessenger } from '@/hooks'

export default defineClassComponent<{
  center?: boolean
  value: number
  data: Array<
    | string
    | {
        label?: string
        title?: string
        name?: string
        value?: any
        id?: any
        cityCode?: any
        cityName?: any
      }
  >
  hasMore?: boolean
}>(
  {
    props: ['center', 'value', 'data', 'hasMore'],
  },
  ({ ctx, props }) =>
    class {
      tabIndex = useMessenger(
        () => props.value,
        v => ctx.$emit('input', v),
      )

      tabData = computed(() =>
        props.data.map(item =>
          typeof item === 'string'
            ? {
                label: item,
                value: item,
              }
            : {
                ...item,
                label: item.label || item.title || item.name || item.cityName,
                value:
                  item.value ||
                  item.id ||
                  item.label ||
                  item.title ||
                  item.name ||
                  item.cityCode,
              },
        ),
      )
    },
)
